import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-background text-foreground font-heading">
      <Navbar />
      
      <div className="pt-32 pb-20 px-6 md:px-12 max-w-[900px] mx-auto">
        <h1 className="text-4xl md:text-5xl font-light mb-2 leading-[1.1]">Informasjonskapselpolicy</h1>
        <p className="text-lg text-foreground/60 mb-12">Sist oppdatert: {new Date().toLocaleDateString('nb-NO')}</p>

        <div className="space-y-8 font-serif text-lg leading-relaxed text-foreground/80">
          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">Hva er informasjonskapsler?</h2>
            <p>
              Informasjonskapsler (cookies) er små tekstfiler som lagres på enheten din når du besøker vår nettside. 
              De brukes til å huske innstillinger, forbedre brukeropplevelsen og analysere trafikk.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">Typer informasjonskapsler vi bruker</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-medium mb-2 text-foreground">Nødvendige informasjonskapsler</h3>
                <p>
                  Disse er essensielle for at nettstedet skal fungere korrekt. De brukes til autentisering, 
                  sikkerhet og grunnleggende funksjonalitet. Du kan ikke deaktivere disse.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-medium mb-2 text-foreground">Funksjonskapslene</h3>
                <p>
                  Disse husker dine innstillinger som språk og tema. De forbedrer brukeropplevelsen på tvers 
                  av besøk.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-medium mb-2 text-foreground">Analysekapslene</h3>
                <p>
                  Vi bruker analysekapslene til å forstå hvordan besøkende bruker vår nettside. 
                  Data samles inn på aggregert form og brukes ikke til identifisering.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-medium mb-2 text-foreground">Markedsføringskapslene</h3>
                <p>
                  Disse brukes til å spore besøkende på tvers av nettsider for å vise relevante annonser. 
                  Du kan velge å reservere deg mot disse.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">Kontroll over informasjonskapsler</h2>
            <p className="mb-4">Du kan kontrollere og slette informasjonskapsler gjennom:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Nettleserens innstillinger</li>
              <li>Vår informasjonskapselbanner når du besøker nettsiden</li>
              <li>Globale ressurser som aboutcookies.org</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">Lagring og sletting</h2>
            <p>
              Informasjonskapsler lagres vanligvis i 12 måneder fra sist besøk. 
              Nødvendige informasjonskapsler kan lagres lengre. Du kan slette informasjonskapsler når som helst 
              gjennom nettleserinnstillingene.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">Tredjepartstjenester</h2>
            <p>
              Vi bruker tredjepartstjenester som Google Analytics for å analysere nettstedtrafikk. 
              Disse tjenestene kan sette sine egne informasjonskapsler. Vi er ikke ansvarlige for deres privatlivspolicyer.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">Kontakt oss</h2>
            <p>
              Hvis du har spørsmål om vår bruk av informasjonskapsler, vennligst kontakt:{' '}
              <a href="mailto:kontakt@lykke.info" className="underline hover:opacity-70">
                kontakt@lykke.info
              </a>
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}